module.exports = __webpack_public_path__ + "public/StoreIcon/groceryorderThree.svg?961bb9da";